import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

const NavPrimary = ( { role, nav, crm, viewing, accts } ) => {
    const [ tabs, setTabs ] = useState( [] );

    useEffect( () => {
        let navIsSet = false;

        if ( viewing?.length === 1 ) {
            const a = accts.find( f => f.id === viewing[0] );
            if ( a?.crm?.meta?.nav ) {
                console.log( 'Acct level nav for: ' + a.id );
                setTabs( a.crm.meta.nav );
                navIsSet = true;
            }
        }
        if ( !navIsSet ) {
            if ( crm?.meta?.nav ) {
                console.log( 'User level nav' );
                setTabs( crm.meta.nav );
            } else if ( nav ) {
                console.log( 'Acct level nav' );
                setTabs( nav );
            }
        }
    }, [ nav, crm, viewing, accts ] );

    useEffect( () => {
        console.log( 'role: ' + role );
    }, [ role ] );

    return (
        <Navbar expand="lg" className="p-0 tf-primary-nav-container">
            <Container fluid>
                <Navbar.Brand href="/">Third Floor</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Link className="nav-link" to="/">Home</Link>
                        {
                            tabs.map( ( n, idx ) => {
                                let show = true;
                                if ( n.restricted ) {
                                    if ( !n.role.includes( role ) ) {
                                        show = false;
                                    }
                                }
                                return ( show ) ? <Link key={`header-nav-${idx}`} className='nav-link' to={n.to}>{n.title}</Link> : <Fragment key={`header-nav-${idx}`} />;
                            } )
                        }
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

const mapProps = ( state ) =>( {
    role: state.user.role,
    nav: state.user.meta.nav,
    crm: state.user.crm,
    viewing: state.user.viewing,
    accts: state.user.lists.accounts
} );

const mapDispatch = ( dispatch ) => ( {
    // setContact: dispatch.contacts.setContact,
} );

export default connect( mapProps, mapDispatch )( NavPrimary );